import { connect } from 'react-redux';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
    fetchAllTypeaheadDeviceTypes,
    fetchAllTypeaheadMobileDeviceTypes,
} from '../../../actions';
import MultiTypeahead from './MultiTypeahead';

function renderSuggestion(suggestion, { inputValue }) {
    const matches = match(suggestion.label, inputValue);
    const parts = parse(suggestion.label, matches);

    return (
        <span
            style={{
                lineHeight: suggestion.isDeviceTypeCategory ? 2 : 1.5,
                color: suggestion.isDeviceTypeCategory ? '#005cb7' : '#000'
            }}
        >
            {parts.map((part, index) =>
                part.highlight ? (
                    <span
                        key={String(index)}
                        style={{ fontWeight: suggestion.isDeviceTypeCategory ? 800 : 600 }}
                    >
                        {part.text}
                    </span>
                ) : (
                    <strong
                        key={String(index)}
                        style={{ fontWeight: suggestion.isDeviceTypeCategory ? 600 : 400 }}
                    >
                        {part.text}
                    </strong>
                )
            )}
        </span>
    );
}

function renderSectionTitle() {
    return '';
}

class DeviceTypeTypeahead extends Component {
    static propTypes = {
        labelId: PropTypes.string,
        fetchAllTypeaheadDeviceTypes: PropTypes.func.isRequired,
        fetchAllTypeaheadMobileDeviceTypes: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        required: PropTypes.bool,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        typeOfSearch: PropTypes.string,
        isMulti: PropTypes.bool,
        animatedPlaceholder: PropTypes.bool,
        renderSectionTitle: PropTypes.func,
        renderSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        labelId: 'deviceType',
        typeOfSearch: 'device',
        renderSectionTitle,
        renderSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            switch (this.props.typeOfSearch) {
                case 'mobile':
                    await this.props.fetchAllTypeaheadMobileDeviceTypes(DeviceTypeTypeahead.name);
                    break;
                case 'device':
                default:
                    await this.props.fetchAllTypeaheadDeviceTypes(DeviceTypeTypeahead.name);
                    break;
            }
        } finally {
            this.setState({ isLoading: false });
        }
    };

    onChangeSuggestion = selectedSuggestions => {
        const { onChangeSuggestion } = this.props;

        const suggestions = selectedSuggestions || [];

        const selectedCategorySuggestion = suggestions.find(({ isDeviceTypeCategory }) => isDeviceTypeCategory);

        if (selectedCategorySuggestion) {
            const selectedDeviceTypeSuggestions = suggestions.filter(
                ({ deviceTypeCategory }) =>
                    deviceTypeCategory && deviceTypeCategory.id !== selectedCategorySuggestion.value
            );

            selectedDeviceTypeSuggestions.push(...selectedCategorySuggestion.categoryDeviceTypes);

            onChangeSuggestion(selectedDeviceTypeSuggestions);
        } else {
            onChangeSuggestion(suggestions);
        }
    };

    selectFilterOption = ({ data }, inputValue) => {
        const { value: selectedDeviceTypes } = this.props;
        const { label, deviceTypeCategory, isDeviceTypeCategory, categoryDeviceTypes } = data;

        if (!label) return null;

        let shouldShowOption = false;

        const trimmedLowerCasedInput = inputValue.trim().toLowerCase();

        if (isDeviceTypeCategory) {
            const isDeviceTypeCategoryMatched = label.toLowerCase().includes(trimmedLowerCasedInput);
            const isAnyDeviceTypeMatched = categoryDeviceTypes.some(deviceType =>
                deviceType.label.toLowerCase().includes(trimmedLowerCasedInput)
            );

            const isAllCategoryDeviceTypesSelected = categoryDeviceTypes.every(
                deviceType => !!selectedDeviceTypes.find(({ value }) => value === deviceType.value)
            );

            return (isDeviceTypeCategoryMatched || isAnyDeviceTypeMatched) && !isAllCategoryDeviceTypesSelected;
        } else {
            const isDeviceTypeMatched = label.toLowerCase().includes(trimmedLowerCasedInput);
            const isDeviceTypeCategoryMatched =
                deviceTypeCategory && deviceTypeCategory.name.toLowerCase().includes(trimmedLowerCasedInput);

            shouldShowOption = isDeviceTypeMatched || isDeviceTypeCategoryMatched;
        }

        return shouldShowOption;
    };

    render() {
        const {
            required,
            error,
            labelId,
            isMulti,
            animatedPlaceholder,
            suggestions,
            value,
            renderSuggestion,
            renderSectionTitle,
            t
        } = this.props;
        const { isLoading } = this.state;

        return (
            <MultiTypeahead
                required={required}
                error={error}
                titleId={labelId}
                isMulti={isMulti}
                isLoading={isLoading}
                animatedPlaceholder={animatedPlaceholder}
                options={suggestions}
                value={value}
                onChangeSuggestion={this.onChangeSuggestion}
                selectFilterOption={this.selectFilterOption}
                formatGroupLabel={renderSectionTitle}
                formatOptionLabel={renderSuggestion}
                onFocus={this.onFocus}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === DeviceTypeTypeahead.name ? typeahead.list : DeviceTypeTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadDeviceTypes,
    fetchAllTypeaheadMobileDeviceTypes,
})(DeviceTypeTypeahead);
